import axios from 'axios';

export const endpoints = {
    autorizeByApplication: `account/signin/`
};

export const autorizeByApplication = data => {
    return axios.post(endpoints.autorizeByApplication, data);
};